import React from 'react'
import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'
import BrandForm from '@components/brand/BrandForm'

export default function BrandSettingsPage () {
  const { brandSlug } = useParams<any>()

  return (
    <div className="BrandSettingsPage">
      <h1 className="u-heading">Настройки бренда #{brandSlug}</h1>
      <Panel shaded>
        <BrandForm slug={brandSlug} />
      </Panel>
    </div>
  )
}
